import { Component, signal } from '@angular/core';
import { NavigationEnd, NavigationStart, Router, RouterOutlet } from '@angular/router';
import { filter } from 'rxjs';
import { Toolbar } from './common/component/toolbar/toolbar';

@Component({//la décoration permet à Angular de lancer le constructor
  selector: 'app-root',
  imports: [RouterOutlet, Toolbar],
  templateUrl: './app.html',
  styleUrl: './app.scss'
})
export class App {

  protected showHeader:boolean = true;
  protected showHeaderCount:number = 0;
  protected readonly title = signal('Figaro test import');

  constructor(private _router: Router) {
  }

  ngOnInit(): void {//préconisé pour faire des initialisation à la place du constructeur
                  //car si erreur d'init, le composant est quand même instancié

    //gestion du header d'info pour le faire disparaitre après avoir navigué dans 2 pages
    this._router.events.pipe(
        filter((event): event is NavigationStart => event instanceof NavigationStart)
    ).subscribe((event:NavigationStart) => {
      
      if (this.showHeader && this.showHeaderCount++>=1) {
        console.log("je fais disparaitre le header")
        this.showHeader = false
      }
    })

    //test : ca sert pas trop car la page longue à s'afficher démarre ses calcul après le NavigationEnd
    this._router.events.subscribe(event => {
      if (event instanceof NavigationStart) {
        console.log("je dois faire apparaitre un spinner")
      }
      if (event instanceof NavigationEnd) {
        console.log("je dois désactiver le spinner")
      }
    })
  } 
                      
}
